import { Icon } from '@chakra-ui/react';
import { forwardRef } from 'react';

export const CustomChevronLeftIcon = forwardRef(({ strokeWidth, ...props }, ref) =>
  strokeWidth !== undefined ? (
    <Icon viewBox="0 0 24 24" ref={ref} {...props}>
      <path
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 18l-6-6 6-6"
      />
    </Icon>
  ) : (
    <Icon viewBox="0 0 24 24" ref={ref} {...props}>
      <path
        fill="currentColor"
        d="M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"
      />
    </Icon>
  )
);
